export { default } from '@shikijs/langs/yaml'
